import { StaticCaseFilterDropdownData } from "@/rca-types";
import { DATE_RANGE_OPTIONS, RiskPattern } from "../constants";

const _filters: StaticCaseFilterDropdownData = {
  // Static group
  riskPattern: [
    { text: RiskPattern.bank, value: "bank" },
    { text: RiskPattern.disc, value: "disc" },
    { text: RiskPattern.card, value: "card" },
    { text: RiskPattern.sams, value: "sams" },
    { text: RiskPattern.void, value: "void" }
  ],
  date: [
    {
      text: DATE_RANGE_OPTIONS.ONE_YEAR_TEXT,
      value: DATE_RANGE_OPTIONS.ONE_YEAR_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.LAST_24_HRS_TEXT,
      value: DATE_RANGE_OPTIONS.LAST_24_HRS_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.ONE_WEEK_TEXT,
      value: DATE_RANGE_OPTIONS.ONE_WEEK_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.TWO_WEEK_TEXT,
      value: DATE_RANGE_OPTIONS.TWO_WEEK_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.ONE_MONTH_TEXT,
      value: DATE_RANGE_OPTIONS.ONE_MONTH_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.THREE_MONTHS_TEXT,
      value: DATE_RANGE_OPTIONS.THREE_MONTHS_VALUE
    },
    {
      text: DATE_RANGE_OPTIONS.SIX_MONTHS_TEXT,
      value: DATE_RANGE_OPTIONS.SIX_MONTHS_VALUE
    }
  ],
  progressStatus: [
    {
      text: "New case",
      value: "New case"
    },
    {
      text: "Assigned",
      value: "Assigned"
    },
    {
      text: "Under investigation",
      value: "Under investigation"
    },
    {
      text: "Closed",
      value: "Closed"
    }
  ],
  riskLevel: [
    { text: "Low risk", value: "low" },
    { text: "Medium risk", value: "med" },
    { text: "High risk", value: "high" }
  ]
};

export default _filters;
